import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface px-4 grid-skeleton">
      <div className="w-full max-w-sm bg-white border border-line shadow-xl">
        <div className="h-1.5 bg-brand" />
        <div className="p-8">
          <Link to="/" className="inline-flex items-center gap-2 text-xs text-ink-muted hover:text-brand mb-6">
            <ArrowLeft className="w-3.5 h-3.5" /> Home
          </Link>
          <div className="w-11 h-11 bg-brand/10 text-brand flex items-center justify-center mb-5">
            <Lock className="w-5 h-5" />
          </div>
          <h1 className="font-heading font-black text-2xl text-ink">Area Admin</h1>
          <p className="text-sm text-ink-muted mt-1">Accedi per gestire offerte e referral.</p>

          <form onSubmit={handleSubmit} className="mt-7 space-y-5">
            <div>
              <label className="label-eyebrow text-ink-muted">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="admin-email-input"
                className="w-full bg-transparent border-b-2 border-line focus:border-brand py-2.5 outline-none transition-colors text-ink"
                placeholder="admin@multiservizi.it"
              />
            </div>
            <div>
              <label className="label-eyebrow text-ink-muted">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="admin-password-input"
                className="w-full bg-transparent border-b-2 border-line focus:border-brand py-2.5 outline-none transition-colors text-ink"
                placeholder="••••••••"
              />
            </div>
            {error && <div className="text-sm text-destructive" data-testid="admin-login-error">{error}</div>}
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full bg-brand hover:bg-brand-dark text-white font-medium py-3 transition-colors disabled:opacity-60"
            >
              {loading ? "Accesso…" : "Accedi"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
